import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CommonDataService } from "./common-data.service";
import { GraphqlService } from "./graphql.service";
import scrollIntoView from 'scroll-into-view-if-needed';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../common/shared-components/confirm-dialog/confirm-dialog.component';
import { constObj } from '../../common/Constants/constants';

@Injectable({
  providedIn: 'root'
})

export class OpenLinkById {

  constructor(private route: Router, private graphQlService: GraphqlService, private commonDataService: CommonDataService, public dialog: MatDialog) { }
  url: string = "";
  linkClicked(event) {
    const path : any = event.composedPath() as Array<any>;
    event.preventDefault();
    const firstAnchor = path.find(p => p.tagName && p.tagName.toLowerCase() === 'a' && p.className == "xref");
    const ditamap = path.find(p => p.tagName && p.tagName.toLowerCase() === 'a' && p.className == "ditamap");
    
    if (firstAnchor && !firstAnchor.hasAttribute('routerlink')) {
      let href = firstAnchor.getAttribute('href');
      let otherSourceUrlParts = href.split("/");
      let otherSourceUrlLastPart = href.includes('#') ? href.split('#')[1] : otherSourceUrlParts[otherSourceUrlParts.length - 1];
      let pageHeading=document.getElementById("pageHeading");
      let secPageHeading = document.getElementById("pageHeadingSec");
      this.commonDataService.showAllPageUrlClicked.subscribe(data => { this.url = data;})
      if (((pageHeading != null || secPageHeading != null || window.location.href.includes("showallinonepage")) && (pageHeading?.innerHTML?.toLocaleLowerCase().includes("glossary") || secPageHeading?.innerHTML?.toLocaleLowerCase().includes("glossary") || window.location.href.includes("showallinonepage")) && isNaN(Number(firstAnchor.innerText.split("-")[0])) && !firstAnchor.innerText.toLocaleLowerCase().includes(("Accounting Standards Update").toLocaleLowerCase())
      && !firstAnchor.innerText.toLocaleLowerCase().includes(("Maintenance Update").toLocaleLowerCase()) && !firstAnchor.innerText.toLocaleLowerCase().includes(("html").toLocaleLowerCase()) && !firstAnchor.innerText.toLocaleLowerCase().includes(("subsection").toLocaleLowerCase())
        && !firstAnchor.innerText.toLocaleLowerCase().includes(("example").toLocaleLowerCase()) && !firstAnchor.innerText.toLocaleLowerCase().includes(("paragraph").toLocaleLowerCase()) && firstAnchor.innerText.toLowerCase().trim() != 'about the codification' )){
        // this.route.navigateByUrl("MasterGlossary");
        // this.commonDataService.glossaryTerm.next(firstAnchor.innerText);
        this.commonDataService.glossaryTermId.next(otherSourceUrlLastPart);
        this.commonDataService.showRightPanel.next(true);
        this.commonDataService.rightOverlayOption.next("inline-glossary");
        this.commonDataService.rightPanelWidth.next("rightOverLay_small");
      }
      else if (firstAnchor.innerText.toLocaleLowerCase().includes("maintenance update") || firstAnchor.innerText.toLocaleLowerCase().includes("accounting standards update") || firstAnchor.innerText.toLocaleLowerCase().includes(("section")) || firstAnchor.innerText.toLocaleLowerCase().includes("subsection")) {
        otherSourceUrlParts = event.target.getAttribute('href').split("/");
        otherSourceUrlLastPart = event.target.getAttribute('href').includes('#') ? event.target.getAttribute('href').split('#')[1] : otherSourceUrlParts[otherSourceUrlParts.length - 1];
        //this.route.navigateByUrl(otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/" + otherSourceUrlParts[otherSourceUrlParts.length - 1]);
        this.popupRedirect(otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/" + otherSourceUrlLastPart);
      }
      else if (firstAnchor.innerText.toLocaleLowerCase().includes("notice to constituents")) {
        otherSourceUrlParts = event.target.getAttribute('href').split("/");
        //this.route.navigateByUrl(otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/noticeToConstituents");
        this.popupRedirect(otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/noticeToConstituents");
      }
      else {
        let firstAnchorInnerText = "";
        if (firstAnchor.innerText.includes("(")) {
        firstAnchorInnerText = firstAnchor.innerText.split("(")[0];
        }
        if (firstAnchor.innerText.includes("[")) {
          firstAnchorInnerText = firstAnchor.innerText.split("[")[0];
        }
        if (firstAnchor.innerText.includes("to")) {
          firstAnchorInnerText = firstAnchorInnerText != "" ? firstAnchorInnerText.split(" to")[0] : firstAnchor.innerText.split(" to")[0];
        }
        if (firstAnchor.innerText.includes("through")) {
          firstAnchorInnerText = firstAnchorInnerText != "" ? firstAnchorInnerText.split(" through")[0] : firstAnchor.innerText.split(" through")[0];
        }
        if ((!this.route.url.includes("showallinonepage") && (this.route.url.split("/")[2] != otherSourceUrlParts[2])) || (this.route.url.includes("showallinonepage") && (this.url.split("/")[1] != otherSourceUrlParts[2]))) {
          if (firstAnchor.innerText.includes("-") && firstAnchor.innerText.split("-").length >= 2) {
            let navSplit = firstAnchor.innerText.split("-");
            let url = this.getBreadcrumbWithNavPath(navSplit[0] + "-" + navSplit[1] + "-" + navSplit[2]);
            let otherSourceUrl = "/" + url + "/" + (firstAnchorInnerText != "" ? firstAnchorInnerText : firstAnchor.innerText);
            //this.route.navigate([otherSourceUrl]);
            this.popupRedirect([otherSourceUrl],true);
          }
          else {
            if (firstAnchor.innerText.toLowerCase().trim() == 'about the codification') {
              //this.route.navigate(['/about-us']);
              this.popupRedirect(['/about-us']);

            } else {
              let otherSourceUrl = "/" + otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/" + otherSourceUrlLastPart;
              //this.route.navigate([otherSourceUrl]);
              this.popupRedirect([otherSourceUrl,true]);
            }
        }
      }
        else {
          if (firstAnchor.innerText.includes("-")) {
            let url: string = "";
            if (this.route.url.includes("-") && this.route.url.split("-").length >= 2) {

              let navSplit = this.route.url.split("/")[this.route.url.split("/").length - 1];
              let urlFetched = this.getBreadcrumbWithNavPath(navSplit[0] + "-" + navSplit[1] + "-" + navSplit[2]);
              url = urlFetched + "/" + (firstAnchorInnerText != "" ? firstAnchorInnerText : firstAnchor.innerText);
            }
            else {
              url = this.route.url + "/" + (firstAnchorInnerText != "" ? firstAnchorInnerText : firstAnchor.innerText);
            }
            //history.pushState(historyData, "scrollUrl", url);
            //  scrollIntoViewIfNeeded(firstAnchornode, {
            //      block: 'start',
            //      inline: 'start',
            //      boundary: document.getElementsByTagName('app-main-content')[0]
            //  });
            this.route.navigateByUrl(url);
        }
        else {
            var otherSourceUrlPartsnode = document.getElementById(otherSourceUrlLastPart);
            scrollIntoView(otherSourceUrlPartsnode, {
            scrollMode: 'always',
            block: 'start',
            inline: 'start',
            boundary: document.getElementsByTagName('app-main-content')[0]})
        }
      }
    }
    }
    else if (ditamap != null) {
      let navPath = ditamap.innerText.split("-");
      if (navPath.length >= 3) {
        let navPathUrl: string = "";
        let tempData = JSON.parse(localStorage.getItem("leftNavigationMenu"));
        if (tempData != undefined && tempData != null) {
          if (navPath[0].includes("Section ")) {
            navPath[0] = navPath[0].replace("Section ", "");
          }
          navPathUrl = this.getBreadcrumbWithNavPath(navPath[0] + "-" + navPath[1] + "-" + navPath[2]);
        }
        else {
          this.graphQlService.getNavPathTree(navPath[0] + "-" + navPath[1] + "-" + navPath[2]).subscribe(data => { navPathUrl = data; });
        }
        if (this.route.url.split("/")[2] != navPathUrl.split("/")[1]) {
          //this.route.navigateByUrl(navPathUrl + "/" + navPath[0] + "-" + navPath[1] + "-" + navPath[2]);
          this.popupRedirect(navPathUrl + "/" + navPath[0] + "-" + navPath[1] + "-" + navPath[2]);
        }
        else {
          var ditamapnode = document.getElementById(ditamap.innerText);
          scrollIntoView(ditamapnode, {
            scrollMode: 'always',
            block: 'start',
            inline: 'start',
            boundary: document.getElementsByTagName('app-main-content')[0]
          })
        }
      }
      else {
        //this.route.navigateByUrl("/" + ditamap.innerText + "/tableOfContent");
        this.popupRedirect("/" + ditamap.innerText + "/tableOfContent");
      }
    }
    else {
      this.openLinkById(event);
    }
  }

  openLinkById(event, isSitesBucket = false) {

    let id = event.target.getAttribute('id');

    let glossary_term_class=event?.target?.className;
    localStorage.setItem("searchNav", event.target.getAttribute("attr.data-message"));
    localStorage.setItem("isSearchLink", event.target.getAttribute("attr.data-issearchlink"));
    if (id !== null) {
      if (id.trim()[0] === '/') {
        //this.route.navigateByUrl(id);
        this.popupRedirect(id);
      }
      else if ((id.includes('.')) && (id.split('.').pop() === 'pdf')) {

        let url = '/layoutComponents/getPdf?isSitesBucket=' + isSitesBucket +'&fileName=' + id;
        window.open(url);

      }
      else if(id.includes('http')) {
        window.open(id);
      }
      else if (glossary_term_class == "term") {
        this.commonDataService.glossaryTermId.next("");
        if (id != "" && id != null) {
          this.commonDataService.glossaryTermId.next(id);
          this.commonDataService.showRightPanel.next(true);
          this.commonDataService.rightOverlayOption.next("inline-glossary");
          this.commonDataService.rightPanelWidth.next("rightOverLay_small");
          if(this.route.url=="/crossreference")
          {
            this.commonDataService.glossaryFromCrossReference.next(true);
            this.commonDataService.NavigatingFromComponent.next("ContentPage");
            this.commonDataService.childComponent.next(true);
          }
          else if(this.route.url=="/pendingcontentsystem" || this.route.url=="/pendingcontentintegeration"){
             this.commonDataService.NavigatingFromComponent.next("PendingContentviewer");
             this.commonDataService.childComponent.next(true);
          }
          else{
            this.commonDataService.glossaryFromCrossReference.next(false);
          }
        }
      }
    }
  }

  getBreadcrumbWithNavPath(breadcerumbUrl) {
    let navPathUrl = "";
    let tempData = JSON.parse(localStorage.getItem("leftNavigationMenu"));
    for (let i = 8; i >= 0; i--) {
      if (tempData[i].itemData != null) {
        for (let j = 0; j < tempData[i].itemData.length; j++) {
          if (tempData[i].itemData[j]?.navPath?.startsWith(breadcerumbUrl)) {
            navPathUrl = tempData[i].itemData[j]?.itemLink;
            return navPathUrl;
          } else {
            if (tempData[i].itemData[j].itemData != null) {
              for (let k = 0; k < tempData[i].itemData[j].itemData.length; k++) {
                if (tempData[i].itemData[j].itemData[k]?.navPath?.startsWith(breadcerumbUrl)) {
                  navPathUrl = tempData[i].itemData[j].itemData[k]?.itemLink;
                  return navPathUrl;
                } else {
                  if (tempData[i].itemData[j].itemData[k].itemData != null) {
                    for (let l = 0; l < tempData[i].itemData[j].itemData[k].itemData.length; l++) {
                      if (tempData[i].itemData[j].itemData[k].itemData[l]?.navPath?.startsWith(breadcerumbUrl)) {
                        navPathUrl = tempData[i].itemData[j].itemData[k].itemData[l]?.itemLink;
                        return navPathUrl;
                      }
                      else {
                        if (tempData[i].itemData[j].itemData[k].itemData[l].itemData != null) {
                          for (let m = 0; m < tempData[i].itemData[j].itemData[k].itemData[l].itemData.length; m++) {
                            if (tempData[i].itemData[j].itemData[k].itemData[l].itemData[m]?.navPath?.startsWith(breadcerumbUrl)) {
                              navPathUrl = tempData[i].itemData[j].itemData[k].itemData[l].itemData[m]?.itemLink;
                              return navPathUrl;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return "";
  }
  /* Start -- Print queue functionality request MS-415*/
  popupRedirect(url, x?) {

    const PrintQueueSession = localStorage.getItem("SetPrintQueueSession");
    var printQueueCount: any = PrintQueueSession == "{}" ? 0 : PrintQueueSession == null ? 0 : PrintQueueSession == "" ? 0 : JSON.parse(localStorage.getItem("SetPrintQueueSession")).ParagraphIdsList.length;
    if (printQueueCount > 0) {
      localStorage.setItem("isConfirmPopup", 'true');
      this.commonDataService.isConfirmationPopUpOpen.next(true);
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '600px',
        data: constObj.annotationAlertPrintQueue
      });
      dialogRef.afterClosed().subscribe((result: boolean) => {
        localStorage.removeItem("isConfirmPopup");
        if (result == true) {
          x ? this.route.navigate(url):this.route.navigateByUrl(url);
        }
      });
      return;
    } else {
      x ? this.route.navigate(url) : this.route.navigateByUrl(url);     
    }

  }
  /* End -- Print queue functionality request MS-415*/
}
